export default __webpack_public_path__ + "static/media/solutionset_completed.333a0ea5.svg";